var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 9.62457L14.9675 9.62457L10.8837 14.5296C10.6928 14.7593 10.6009 15.0555 10.6284 15.353C10.6558 15.6505 10.8003 15.9249 11.03 16.1158C11.2597 16.3068 11.5559 16.3986 11.8534 16.3712C12.1509 16.3438 12.4253 16.1993 12.6163 15.9696L18.2413 9.21957C18.2791 9.16588 18.3129 9.10948 18.3425 9.05082C18.3425 8.99457 18.3425 8.96082 18.4213 8.90457C18.4722 8.77558 18.4989 8.63827 18.5 8.49957C18.4989 8.36087 18.4722 8.22356 18.4213 8.09457C18.4213 8.03832 18.4213 8.00457 18.3425 7.94832C18.3129 7.88966 18.2791 7.83326 18.2413 7.77957L12.6163 1.02957C12.5105 0.902575 12.378 0.800447 12.2283 0.730448C12.0786 0.660449 11.9153 0.624298 11.75 0.624567C11.4871 0.624053 11.2324 0.7156 11.03 0.883316C10.9161 0.97776 10.8219 1.09375 10.7529 1.22464C10.6839 1.35553 10.6414 1.49875 10.6278 1.6461C10.6142 1.79345 10.6298 1.94203 10.6737 2.08333C10.7177 2.22464 10.789 2.35589 10.8837 2.46957L14.9675 7.37457L1.625 7.37457C1.32663 7.37457 1.04048 7.49309 0.829503 7.70407C0.618525 7.91505 0.499999 8.2012 0.499999 8.49957C0.499999 8.79793 0.618525 9.08408 0.829503 9.29506C1.04048 9.50604 1.32663 9.62457 1.625 9.62457Z",
    fill: "#03565A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreen);
export default __webpack_public_path__ + "static/media/arrowGreen.a8e3e0f51d52849fee1539174f659c0e.svg";
export { ForwardRef as ReactComponent };